import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { showToast } from "../utils/showToast";
import { getMainDefinition } from "@apollo/client/utilities";
import { WebSocketLink } from "@apollo/client/link/ws";

//TODO: use env fot the ws and http links a
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
});

// const wsLink = new GraphQLWsLink(
//   createClient({
//     url: "wss://ecomoto-mvp-7aptqvbwca-uc.a.run.app/graphql",
//     // connectionParams: {
//     //   authToken: localStorage.getItem("zzzzzzzz"),
//     // },
//     // // lazy: true,
//     // shouldRetry(errOrCloseEvent: any) {
//     //   const maybeWsError = "WebSocketError" in errOrCloseEvent;
//     //   if (maybeWsError) {
//     //     console.error("WebSocket error", errOrCloseEvent);
//     //   }
//     //   return true;
//     // },
//     // on: {
//     //   error: (err) => {
//     //     console.error("Got error", err);
//     //   },
//     //   closed: () => {
//     //     console.log("Connection closed");
//     //   },
//     // },
//   })
// );

// const wsLink = new WebSocketLink(
//   new SubscriptionClient("wss://ecomoto-mvp-7aptqvbwca-uc.a.run.app/graphql")
// );

export const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_WEBSOCKET_URL ?? "", // use wss for a secure endpoint
  options: {
    reconnect: true,
  },
});

// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from state if it exists
  const accessToken = localStorage.getItem("zzzzzzzz");
  // const accessToken = useSelector((state: any) => state.user.accessToken);

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: accessToken ? `Bearer ${accessToken}` : "",
    },
  };
});

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        switch (err.extensions?.code) {
          // Apollo Server sets code to UNAUTHENTICATED
          // when an AuthenticationError is thrown in a resolver
          case "UNAUTHENTICATED":
            // // Modify the operation context with a new token
            // const oldHeaders = operation.getContext().headers;
            // operation.setContext({
            //   headers: {
            //     ...oldHeaders,
            //     authorization: getNewToken(),
            //   },
            // });
            // // Retry the request, returning the new observable
            // return forward(operation);
            if (
              window.location.pathname !== "/" &&
              window.location.pathname !== "/auth"
              // window.location.pathname !== "/vehicles"
            ) {
              console.log("Session has expired");
              showToast("Login to continue", "error");
              // redirect("/auth");
              window.localStorage.setItem(
                "authFailLocation",
                window.location.pathname
              );

              window.location.href = "/auth";
            }

            return;
        }
      }
    }

    // To retry on network errors, we recommend the RetryLink
    // instead of the onError link. This just logs the error.
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
    }
  }
);

const client = new ApolloClient({
  link: from([errorLink, authLink.concat(splitLink)]),
  // link: splitLink,
  cache: new InMemoryCache(),
});

export default client;
